/**
 * Smart timestamp formatting with date context
 * @param timestamp - ISO timestamp string
 * @returns Formatted time string based on context (today, yesterday, or full date)
 */
export const getFormattedTime = (timestamp: string): string => {
  try {
    const messageDate = new Date(timestamp);
    if (isNaN(messageDate.getTime())) {
      const now = new Date();
      return now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });
    }

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const messageDay = new Date(
      messageDate.getFullYear(),
      messageDate.getMonth(),
      messageDate.getDate()
    );

    const timeString = messageDate.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });

    if (messageDay.getTime() === today.getTime()) {
      // Today: only show time
      return timeString;
    } else if (messageDay.getTime() === yesterday.getTime()) {
      // Yesterday: show "Yesterday, HH:MM"
      return `Yesterday, ${timeString}`;
    } else {
      // Other dates: show "DD/MM/YYYY, HH:MM"
      const dateString = messageDate.toLocaleDateString([], {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
      return `${dateString}, ${timeString}`;
    }
  } catch (error) {
    console.error('Error formatting timestamp:', error);
    const now = new Date();
    return now.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  }
};
